import { useEffect, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

const navItems = [
  { to: '/', label: '首页', end: true },
  { to: '/guoman', label: '国漫' },
  { to: '/riman', label: '日漫' },
  { to: '/top', label: '人气榜单' },
  { to: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/guoman?q=${encodeURIComponent(q)}` : '/guoman');
    setMenuOpen(false);
  };

  return (
    <header className={`sticky top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-background-50'}`}>
      <nav className="mx-auto flex max-w-7xl items-center gap-4 px-4 md:px-6 h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="虫虫漫画首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-bug-2-line text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-xl md:text-2xl text-foreground-950 tracking-wide">
            虫虫<span className="text-primary-500">漫画</span>
          </span>
        </Link>

        <ul className="hidden md:flex items-center gap-1 ml-2">
          {navItems.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                    isActive ? 'bg-primary-500 text-background-50' : 'text-foreground-700 hover:text-primary-600'
                  }`
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <form onSubmit={submitSearch} className="hidden lg:flex items-center flex-1 max-w-xs ml-auto bg-background-100 rounded-full pl-4 pr-1.5 h-10 border border-background-200">
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            type="search"
            placeholder="搜漫画标题或题材"
            className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 outline-none"
            aria-label="搜索漫画"
          />
          <button type="submit" className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors" aria-label="搜索">
            <i className="ri-search-line text-sm"></i>
          </button>
        </form>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className="md:hidden ml-auto flex h-10 w-10 items-center justify-center rounded-lg bg-background-100 text-foreground-900"
          aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 animate-pop">
          <form onSubmit={submitSearch} className="flex items-center bg-background-100 rounded-full pl-4 pr-1.5 h-10 border border-background-200 mb-2">
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="search"
              placeholder="搜漫画标题或题材"
              className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
              aria-label="搜索漫画"
            />
            <button type="submit" className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50" aria-label="搜索">
              <i className="ri-search-line text-sm"></i>
            </button>
          </form>
          <ul className="flex flex-col gap-1">
            {navItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.end}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) =>
                    `block rounded-lg px-4 py-2.5 text-sm font-medium ${isActive ? 'bg-primary-500 text-background-50' : 'text-foreground-800 hover:bg-background-100'}`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}